
import React, { Component } from 'react';
import { GENERAL } from '../../assets/images/images';
import Helper from '../../core/helper/helper';
import LocalData from '../../core/localData';
import Emitter from '../../core/services';
import Labels from '../../variables/labels';
import { ToastType } from '../../core/types';

/**
 * Props definition
 * @typedef {Object} Props
 * @property {PropsData} data
 * @property {() => void} goToDetails 
 * @property {() => void} onRead 
 * @property {() => void} onReadCheck 
 */

/**
 * PropsData definition
 * @typedef {Object} PropsData
 * @property {'message' | 'check' | 'action' | 'internal' | "PAYMENT" } type  // type of noti (message, check, action, internal notes)
 * @property {string} source  // represents the source of the view (details | BV)
 * @property {boolean} unRead // if notification wasn't read
 * @property {boolean} noFocus // to disable focus
 * @property {boolean} isCompact // if is for a compact card
 */

/**
 * StateData definition
 * @typedef {Object} StateData
 * @property {boolean} notiOpened
 * @property {boolean} iconClicked
 * @property {boolean} unRead // if notification wasn't read
 */

class ShowNotificationButton extends Component {
  constructor(/** @type {Props} */ props) {
    super(props);
    /** @type {Props} */
    const { data: {noFocus, unRead, source, type, fromPayNotif, fromApproveNotif}} = this.props;
    /** @type {StateData} */
    this.state = {
      notiOpened: unRead && !(type === 'message' && source === 'details') 
                  && !noFocus && !fromPayNotif && !fromApproveNotif,
      iconClicked: false,
      unRead,
      type
    }
  }

  /** @param { Props } prevProps */
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      /** @type {Props} */
      const { data: { unRead, type }} = this.props;
      this.setState({unRead, type});
    }
  }

  componentDidMount() {
    /** @type {Props} */
    const { data: { noFocus, fromMessageNotification, fromPayNotif, fromApproveNotif }} = this.props;
    const { type } = this.state;
    /** @type {StateData} */
    const { unRead } = this.state;

    this.getSectionPositions();
    if (type === 'message') {
      if (LocalData.messageIconClicked) {
        setTimeout(() => {this.focusOnObservationsBox();}, 500);
        if (!Helper.isLiteVersion() && unRead) {
          this.props.onRead();
        }
      }
      if (fromMessageNotification && unRead) {
        setTimeout(() => {
          this.setState({ notiOpened: true });
        }, 1000);
         setTimeout(() => {
          this.onClickedLink(fromMessageNotification);
         }, 2000);
      }
    }

    if (LocalData.checkIconClicked && type === 'check') {
      if (!Helper.isLiteVersion() && unRead) {
        this.props.onReadCheck();
      }
    }
    
    if (type === 'action') {
      if (fromApproveNotif) {
        setTimeout(() => {
          this.setState({ notiOpened: true });
        }, 1000);
        setTimeout(() => {
          this.onClickedLink();
        }, 2000);
      }
      if (LocalData.checkIconClicked) {
        this.focusOnApprovalBox(!noFocus);
      }
    }

    if (LocalData.internalIconClicked && type === 'internal') {
      this.focusOnInternalNotesBox();
    }

    if (type === 'payment') {
      if (fromPayNotif) {
        setTimeout(() => {
          this.setState({ notiOpened: true });
        }, 1000);
        setTimeout(() => {
          this.onClickedLink();
        }, 2000);
      }
      if (LocalData.paymentIconClicked) {
        this.focusOnPaymentBox();
      }
    }
  }

  focusOnObservationsBox = (fromMessageNotification = false) => {
    Emitter.emit('OBSERVATIONS_SHINNING', fromMessageNotification);
  }

  focusOnInternalNotesBox = () => {
    if (!this.sectionElement) {
      return;
    }
    this.getSectionPositions();
    const elementBoundary = this.internalContainer?.bottom + 80;
    const elementBoundaryMobile = this.internalContainerMobile?.bottom + 80;

    this.scrollByOffset(elementBoundary, elementBoundaryMobile);
    setTimeout(() => {
      Emitter.emit('INTERNAL_NOTES_SHINNING', true);
      LocalData.internalIconClicked = false;
    }, 500);
  }

  focusOnApprovalBox = (focus) => {
    if (!focus || !this.sectionElement) {
      return;
    }
    this.getSectionPositions();
    const elementBoundary = this.elementRect?.top + 224;
    const elementBoundaryMobile = this.elementRectMobile?.top + 140;

    this.scrollByOffset(elementBoundary, elementBoundaryMobile);
    setTimeout(() => {
      Emitter.emit('APPROVAL_SHINNING', true);
      LocalData.approvalIconClicked = false;
    }, 500);
  }

  focusOnPaymentBox = () => {
    setTimeout(() => {
      Emitter.emit('PAYMENT_SHINNING', true);
      LocalData.paymentIconClicked = false;
    }, 200);
  }

  toggleOpenIcon = (event, clicked) => {
    const { iconClicked, notiOpened } = this.state;
    if (event) {
      event.stopPropagation();
    }
    if (notiOpened ){
      this.setState({notiOpened: false});
    }
    if (!notiOpened) {
      this.setState({notiOpened: true});
    }
    if (clicked) {
      this.setState({iconClicked: !iconClicked});
    }
  }

  onClickedLink = (fromMessageNotification = false) => {
    /** @type {Props} */
    const { data: { type, source, noFocus }} = this.props;
    /** @type {StateData} */
    const { unRead } = this.state;
    if (!source) { //in services view
      if (type === 'message') {
        LocalData.messageIconClicked = true;
      }
      if (type === 'action') {
        LocalData.approvalIconClicked = true;
      }
      if (type === 'payment') {
        LocalData.paymentIconClicked = true;
      }
      if (type === 'check') {
        LocalData.checkIconClicked = true;
      }      
      if (type === 'internal') {
        LocalData.internalIconClicked = true;
      }
      this.props.goToDetails();
      return;
    }
    switch (type) {
      case 'message':
        this.focusOnObservationsBox(fromMessageNotification);
        if (!Helper.isLiteVersion() && unRead) {
          setTimeout(() => {
            this.setState({unRead: false});
            this.props.onRead();
          }, 1000);
        }
        break;
      case 'check':     
        if (!Helper.isLiteVersion() && unRead) {
          this.props.onReadCheck();
          this.setState({unRead: false});
        }
        break;        
      case 'action':
        this.focusOnApprovalBox(!noFocus);
        break;
      case 'internal':
        this.focusOnInternalNotesBox();
        if (!Helper.isLiteVersion()) {
        }
        break;
      case 'payment':
        this.focusOnPaymentBox();
        break;
      default:
        this.focusOnApprovalBox(false);
        break;
    }
  }
  
  renderInfotext = (isCompact) => {
     /** @type {Props} */
    const { data: { type, unRead }} = this.props;
    const notiOpened = this.state?.notiOpened;

    // This call is for the opposite compact mode — render nothing
    if (!isCompact) { return <></>; }

    const renderText = () => {
      const styleClass = (
        type === 'action'
        || type === 'message'
        || type === 'internal'
        || type === ToastType.PAYMENT
      ) && unRead ? 'link-container' : 'regular';
      const toasterTitle = Helper.getToastTitle(unRead, type);
      return (
        <React.Fragment>
          <div>{toasterTitle}</div>
          <div className={styleClass}>
            <span style={{ lineHeight: '19px', display: 'inline-block' }}>
              {Labels.notifications.description[type]}
            </span>
          </div>
        </React.Fragment>
      );
    }

    return (
      <div className={`notification-info-text d-flex align-items-center justify-content-center ${notiOpened ? 'notiOpened' : ''}`}
      >
        <div className={`text-box ${type} d-flex align-items-start justify-content-center px-2`}
          onClick={() => (this.onClickedLink())}>
          { notiOpened && renderText() }
        </div>
      </div>
    );
  }

  getSectionPositions() {
    this.sectionElement = document.getElementById('main-details-container');
    this.sectionTop = this.sectionElement?.getBoundingClientRect()?.top;
    this.sectionBottom = this.sectionElement?.getBoundingClientRect()?.bottom;

    this.bodyTop = window.document.documentElement.getBoundingClientRect()?.top;
    this.bodyBottom = window.document.documentElement.getBoundingClientRect()?.bottom;

    this.elementRect = document.getElementById('service-tasks-list')?.getBoundingClientRect();
    this.elementRectMobile = document.getElementById('service-tasks-list-mobile')?.getBoundingClientRect();

    this.internalContainer =  document.getElementById('internal-notes-container')?.getBoundingClientRect();
    this.internalContainerMobile =  document.getElementById('internal-notes-container-mobile')?.getBoundingClientRect();
  }

  scrollByOffset(ePos, ePosMobile) {
    const offset = ePos - this.sectionTop - this.sectionBottom +  window.innerHeight/1.5;
    const offsetMobile = ePosMobile - this.bodyBottom + window.innerHeight/1.5;

    if (offset > 0) {
      this.sectionElement.scrollTo({ top: offset, behavior: 'smooth' });
    }
    if (offsetMobile > 0) {
      window.document.documentElement.scrollTo({ top: offsetMobile, behavior: 'smooth' });
    }
  }

  render() {
     /** @type {Props} */
    const { data: { type, source, isCompact }} = this.props;
    return (
      <div className={`notification-service-container ${type || ''} ${source || ''} d-flex align-items-center justify-content-center`}>
        {this.renderInfotext(!isCompact)}
        <div className={`notification-icon-box d-flex align-items-center justify-content-center`}
          onClick={(e) => this.toggleOpenIcon(e, true)}
        >
          <img src={GENERAL[type]} alt="" />
        </div>
        {this.renderInfotext(isCompact)}
      </div>
    );
  }
}
export default ShowNotificationButton;
